import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	operatorLabel: {
		id: 'jql-builder-basic-picker.async-select.operator-select.operator-label',
		defaultMessage: 'Operator dropdown',
		description:
			'Label for select dropdown to choose a jql operator, which is used by Screen Reader Users',
	},
});

export default messages;
